import { render, staticRenderFns } from "./TabelaComarca.vue?vue&type=template&id=612997b6&scoped=true&"
import script from "./TabelaComarca.vue?vue&type=script&lang=js&"
export * from "./TabelaComarca.vue?vue&type=script&lang=js&"
import style0 from "./TabelaComarca.vue?vue&type=style&index=0&id=612997b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612997b6",
  null
  
)

export default component.exports